import React, { useState } from "react";
import emailjs from "@emailjs/browser";
import { useTranslation } from "react-i18next";

export default function ContactForm() {
    const { t } = useTranslation();
    const [status, setStatus] = useState("");

    const sendEmail = (e) => {
        e.preventDefault();
        setStatus("sending");

        const formData = new FormData(e.target);
        const templateParams = {
            subject_title: "Общо запитване от сайта",
            inquiry_type: "Контактна форма (Стандартна)",
            from_name: formData.get("user_name"),
            from_email: formData.get("user_email"),
            phone: "Не е предоставен",
            message: formData.get("message"),
        };

        emailjs.send("service_n4kjhbf", "template_5hdvgub", templateParams, "vu-iLvSTPOKJQ0ckO")
            .then(() => {
                setStatus("success");
                e.target.reset();
                setTimeout(() => setStatus(""), 5000);
            })
            .catch(() => setStatus("error"));
    };

    return (
        <div className="contact-form-container">
            {status === "success" && <div className="status-banner success small">{t("contact.successMessage")}</div>}
            {status === "error" && <div className="status-banner error small">{t("contact.errorMessage")}</div>}
            
            <form onSubmit={sendEmail} className="contact-form">
                <input type="text" name="user_name" placeholder={t("contact.namePlaceholder")} required />
                <input type="email" name="user_email" placeholder={t("contact.emailPlaceholder")} required />
                <textarea name="message" placeholder={t("contact.messagePlaceholder")} />
                
                <button type="submit" disabled={status === "sending"}>
                    {status === "sending" ? t("contact.sending") : t("contact.submitButton")}
                </button>
            </form>
        </div>
    );
}

/* 
import React, { useRef } from "react";
import emailjs from "@emailjs/browser";
import { useTranslation } from "react-i18next";

export default function ContactForm() {
    const form = useRef();
    const { t } = useTranslation();

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs
            .sendForm(
                "service_n4kjhbf",
                "template_5hdvgub",
                form.current,
                "vu-iLvSTPOKJQ0ckO"
            )
            .then(
                (result) => {
                    console.log(result.text);
                    alert(t("contact.successMessage")); // Добавена обратна връзка
                    resetForm();
                },
                (error) => {
                    console.log(error.text);
                    alert(t("contact.errorMessage"));
                }
            );
    };

    const resetForm = () => {
        form.current.reset();
    };

    return (
        <form ref={form} onSubmit={sendEmail} className="contact-form">
            <div className="form-group">
                <label htmlFor="user_name"></label>
                <input
                    type="text"
                    id="user_name"
                    name="user_name"
                    placeholder={t("contact.namePlaceholder")}
                    required
                />
            </div>
            <div className="form-group">
                <label htmlFor="user_email"></label>
                <input
                    type="email"
                    id="user_email"
                    name="user_email"
                    placeholder={t("contact.emailPlaceholder")}
                    required
                />
            </div>
            <div className="form-group">
                <label htmlFor="message"></label>
                <textarea
                    id="message"
                    name="message"
                    placeholder={t("contact.messagePlaceholder")}
                />
            </div>
            <button type="submit">{t("contact.submitButton")}</button>
        </form>
    );
}
*/
